import React from "react";
import CorporatePartners from "./CorporatePartners";

const contactData = {
  title: "Our Clients",
  pitch: "Looking for a trusted corporate media partner?",
  emails: ["corporate@hkimedia.com", "rohitdhikyawar@hkimedia.com"],
  phone: "+91 96505 01305",
  address:
    "Plot no. 251, Udyog Vihar Phase 4 Rd, Phase IV, Udyog Vihar, Sector 18, Gurugram, Haryana 122015",
};

const CorporateContact = () => {
  return (
    <section className="corporate_cta_bg corporate_section">
      <div className="container">
        <div className="text-center mb-2 pb-lg-4">
          <h2 className="cta-heading mb-0" style={{ color: "var(--white)" }}>{contactData.title}</h2>
        </div>
        <CorporatePartners />
        <div className="row g-5 mt-2 align-items-start">
          <div className="d-none d-md-flex col-lg-3 col-md-6">
            <p className="cta-grid-pitch">{contactData.pitch}</p>
          </div>

          <div className="col-lg-3 col-md-6 cta-grid-link">
            <span className=""> Email Us</span>
            {contactData.emails.map((email, index) => (
              <a
                key={email}
                href={`mailto:${email}`}
                className={`contact_details cta-grid-link${index === 0 ? " font-regular" : ""}`}
              >
                {email}
              </a>
            ))}
          </div>

          <div className="col-lg-3 col-md-6">
            <a
              href={`tel:${contactData.phone.replace(/\s/g, "")}`}
              className="cta-grid-link"
            >
              <span>Call Us</span>
              {contactData.phone}
            </a>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="cta-grid-label">Headquarters</div>
            <p className="cta-grid-address">{contactData.address}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CorporateContact;
